import { Injectable } from '@angular/core';

export interface CollectionTab {
  label: string;
  collectionName: string;
  description: string;
}

@Injectable({
  providedIn: 'root',
})
export class YardiePicksTabsService {
  private tabs: CollectionTab[] = [
    {
      label: 'Toppa Top',
      collectionName: 'ToppaTop',
      description:
        'Our flagship list. The strongest companies on the market right now — quality businesses with the numbers to back it up.',
    },
    {
      label: 'On Sale',
      collectionName: 'OnSaleNow',
      description:
        'Great companies trading at bargain prices. These names are below fair value and lined up for smart entry points.',
    },
    {
      label: 'Quality Yardies',
      collectionName: 'QualityYardies',
      description:
        'Rock-solid companies built on consistent growth above 15% in all areas. These are steady performers worth keeping on your radar long-term.',
    },
    {
      label: 'Big Mo',
      collectionName: 'BigMo',
      description: 'These are the top performing stocks over the last 1 year (12 months).',
    },
    // {
    //   label: 'Swing Ting',
    //   collectionName: 'SwingTing',
    //   description:
    //     'Stocks on the move. Momentum is on their side, and the fundamentals make them more than just a quick trade. Great for Swing Traders or investors who want "heat" — they care more about near-term movement than long-term valuation.',
    // },
    {
      label: 'Sweet Spot',
      collectionName: 'SweetSpot',
      description:
        'Not overpriced, but not yet on deep discount — sitting right in the middle. A solid range for patient investors and options traders play and collect some income. Great for options strategies like the Wheel or Bull Credit Spreads.',
    },
    {
      label: 'Nanny Bounce',
      collectionName: 'NannyBounce',
      description: 
        'These names don’t just survive pressure, they are poised to bounce hard when the cycle turns. Nanny of the Maroons symbolizes resilience, strength, and strategic endurance, making her the perfect inspiration for this high-confidence WSY list.',
    },
    {
      label: 'Wide Moat',
      collectionName: 'WideMoat',
      description:
        'Companies with a wide economic moat — durable competitive advantages that protect their business from rivals for the long term. These are the kind of businesses that keep competitors at bay for decades.',
    },
    //  {
    //   label: 'Hidden Treasures',
    //   collectionName: 'HiddenTreasure',
    //   description:
    //     "Underrated and undervalued, but powerful. These companies may not be household names, but they're quietly building real strength. For curious investors looking to diversify beyond mega-caps and find tomorrow's stars.",
    // },
    // {
    //   label: 'Pennywise',
    //   collectionName: 'Pennywise',
    //   description: 'Ultra-cheap stocks with strong businesses built to last. Rock-bottom prices, steady long-term potential. For the TRUE value investor who is looking for quality. Low PE, Profitable and cashflow positive for last 5 years.'
    // }
  ];

  getTabs(): CollectionTab[] {
    return this.tabs;
  }

  getTabByCollectionName(collectionName: string): CollectionTab | undefined {
    return this.tabs.find((tab) => tab.collectionName === collectionName);
  }
}
